export enum OrderStatus{
    New = 1,
    Confirmed,
    Processing,
    Shipped,
    Cancelled,
    InReserve
}